/**
 * BranchChip — chip-strip branch selector.
 *
 * Refactored from HeaderProjectSwitcher's branch half. Disabled when no
 * project is selected. Preserves the original wiring: emits raw branch_id
 * up to App.js's setCurrentBranch.
 */
import React from 'react';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from '@mui/material';
import { AccountTree } from '@mui/icons-material';

const BranchChip = ({
  branches = [],
  currentBranch,
  onBranchChange,
  hasProject,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <AccountTree
        sx={{
          color: hasProject ? '#667eea' : 'text.disabled',
          fontSize: 16,
        }}
      />
      <FormControl size="small">
        <Select
          value={currentBranch || ''}
          onChange={(e) => onBranchChange(e.target.value)}
          displayEmpty
          disabled={!hasProject}
          sx={{
            minWidth: 140,
            bgcolor: hasProject
              ? 'background.paper'
              : isDark
                ? 'rgba(255, 255, 255, 0.02)'
                : 'rgba(0, 0, 0, 0.02)',
            '& .MuiSelect-select': { py: 0.5, fontSize: '0.8125rem' },
          }}
          MenuProps={{ PaperProps: { sx: { mt: 0.5 } } }}
        >
          <MenuItem value="" disabled>
            <Typography
              color="text.secondary"
              sx={{ fontStyle: 'italic', fontSize: '0.8125rem' }}
            >
              {hasProject ? 'Select Branch' : '--'}
            </Typography>
          </MenuItem>

          {branches.map((branch) => (
            <MenuItem key={branch.branch_id} value={branch.branch_id}>
              <Typography sx={{ fontSize: '0.8125rem' }}>
                {branch.name}
                {branch.name === 'main' && (
                  <Typography
                    component="span"
                    variant="caption"
                    sx={{ ml: 1, color: 'text.secondary' }}
                  >
                    (protected)
                  </Typography>
                )}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default BranchChip;
